import React from 'react';
import { Parallax } from 'react-parallax';
import Navigation from './Navigation';
import Footer from './Footer';

const Products = props => (
  <div>
    <Navigation navigation={props.navigation} />
    <Parallax blur={0} bgImage="/images/bg-005.jpg" bgImageAlt="" strength={120}>
      <div style={{ height: '300px' }} />
    </Parallax>
    <div className="container pb-2">
      <div className="row">
        <h1
          className="display-1 hidden-down pt-2"
          style={props.data.title.length > 30 ? { fontSize: '4.5em' } : { fontSize: '5em' }}
        >
          {props.data.title}
        </h1>
        <div className="col-xl-4 col-lg-4 col-md-5 pt-2 pb-2" />
      </div>
      <div className="row pt-2">
        <div className="col-md-12 lead">
          <div dangerouslySetInnerHTML={{ __html: props.data.body }} />
        </div>
      </div>
      {props.data.list.map(one => (
        <section className="container outer pb-3 mt-3" key={one.slug}>
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-5 py-2">
              <a href={`/products/${one.slug}`}>
                <h1>{one.title}</h1>
              </a>
            </div>
            <div className="col-xl-4 ml-xl-auto col-lg-4 ml-lg-auto col-md-5 ml-md-auto py-2" />
            <div className="col-sm-12">
              <div className="card card-default py-2">
                <p className="font-italic lead m-0">{one.desc}</p>
              </div>
            </div>
          </div>
          {one.img ? (
            <div className="row">
              <div className="col-md-12">
                <a href={`/products/${one.slug}`}>
                  <img src={one.img} className="post-img img-fluid" alt={one.title} />
                </a>
              </div>
            </div>
          ) : null}
          <div className="row pt-2">
            <div className="col-md-12 pt-3 post-content">
              <div dangerouslySetInnerHTML={{ __html: one.bodyShort }} className="lead" />
              {/* <hr /> */}
            </div>
          </div>
          <hr style={{ border: '2px solid black' }} />
        </section>
      ))}
    </div>
    <Footer />
  </div>
);
export default Products;



// WEBPACK FOOTER //
// ./src/components/Products.js